import React from 'react';

import { createStyles, withStyles, Theme, Grid } from '@material-ui/core';
import Filters from '../../common/AnalyticsFilters';
import commonStyles from '../../common/common.module.css';
import styles from '../analytics.module.css';
import Efficiency from './Efficiency';
import { filterOptions, Teams } from '../../../models/Analytics';
import AnalyticsFromToDate from '../../common/AnalyticsFromToDate';
import { Moment } from 'moment';
import AirlineType from '../../../models/AirlineType';

const materialStyles = (theme: Theme) =>
  createStyles({

  });

interface TeamEfficiencyProps {
  filterOptions: filterOptions;
  startDate: Moment;
  endDate: Moment;
  progress: boolean;
  airlines: AirlineType[];
  startTime: Moment;
  endTime: Moment;
  carrCheck: boolean;
  carr: string;
  pickUp: boolean;
  dropOff: boolean;
  counter: Teams[];
  warehouse: Teams[];
  cSort: string;
  wSort: string;
  handleChangeDate: (dateType: string, event: any) => void;
  handleChangeProcess: (type: string, value: boolean) => void;
  handleChangeCarriers: (type: string, value: boolean) => void;
  handleChangeTime: (type: string, event: any) => void;
  handleChangeOption: (type: string, event: any) => void;
  handleExport: (type: string) => void;
  exceedHours?: number;
  handleExceedHoursChange: (value: number) => void;
};

const TeamEfficiency = (props: TeamEfficiencyProps) => {

  return (
    <div className={`${commonStyles.mt4} ${commonStyles.positionRelative}`}>
      <AnalyticsFromToDate startDate={props.startDate} endDate={props.endDate} progress={props.progress} handleChangeDate={props.handleChangeDate} />
      <Grid container spacing={4} className={`${styles.customerGridContainer}`}>
        <Grid item className={`${styles.customerGridItemsFilter}`}>
          <Filters filterOptions={props.filterOptions} pickUp={props.pickUp} dropOff={props.dropOff} carr={props.carr} carrCheck={props.carrCheck} startTime={props.startTime} endTime={props.endTime} airlines={props.airlines} handleExport={props.handleExport} handleChangeProcess={props.handleChangeProcess} handleChangeTime={props.handleChangeTime} handleChangeCarriers={props.handleChangeCarriers}
              handleExceedHoursChange={props.handleExceedHoursChange}
              exceedHours={props.exceedHours} 
            />
        </Grid>

        <Grid item className={`${styles.customerGridItemsData} ${styles.securityscreening}`}>
          <Grid container spacing={3} className={`${styles.wtOuterGridContainer}`}>
            <Grid item xs={12}>
              <Efficiency type='counter' team={props.counter} sort={props.cSort} handleChangeOption={props.handleChangeOption} handleExport={props.handleExport} />
            </Grid>
            <Grid item xs={12}>
              <Efficiency type='warehouse' team={props.warehouse} sort={props.wSort} handleChangeOption={props.handleChangeOption} handleExport={props.handleExport} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

export default withStyles(materialStyles)(TeamEfficiency);
